import { isCheckupRoute } from "@/application/router/utils/utils";
import { checkupRouteNames } from "@/application/router/checkup";
import type { NavigationGuardWithThis } from "vue-router";
import { checkupStepGuard } from "@/application/router/guards/checkupStepGuard";
import { Finanzmanager } from "@/application/router/types/types";
import { useBaseDataStore } from "@/user/store/baseDataStore";

export const checkupBeforeGuard: NavigationGuardWithThis<undefined> = (to, from) => {
  if (isCheckupRoute(to, checkupRouteNames)) {
    if (useBaseDataStore().isCompany !== false) {
      return { name: Finanzmanager.VERTRAEGE };
    }

    return checkupStepGuard(to, from);
  }

  return true;
}
